import { Component, computed, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { AccountService } from '../../account.service';
import { SignalsStoreService } from '../../signals-store.service';
import { DISCLAIMER_MESSAGES, DISCLAIMER_TYPES } from '../../constants/databases';
import { NotificationService } from '../../notification/notification.service';
import { ResolutionService } from '../../resolution.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-checkout-disclaimer',
  imports: [],
  templateUrl: './new-checkout-disclaimer.component.html',
  styleUrl: './new-checkout-disclaimer.component.scss'
})
export class NewCheckoutDisclaimerComponent implements OnInit, OnDestroy {

  #accountService = inject(AccountService);
  #signalsStoreService = inject(SignalsStoreService);
  #notificationService = inject(NotificationService);
  #resolutionsService = inject(ResolutionService);
  #activeModal = inject(NgbActiveModal);

  isMobile = computed(() => this.#resolutionsService.isMobile());
  countdown = signal(5);

  private countdownInterval: number | undefined;

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    this.clearCountdown();
  }

  private startCountdown() {
    this.countdownInterval = window.setInterval(() => {
      const currentValue = this.countdown();
      if (currentValue > 0) {
        this.countdown.set(currentValue - 1);
      } else {
        this.clearCountdown();
      }
    }, 1000);
  }

  private clearCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = undefined;
    }
  }

  acceptCheckoutChange() {
    this.#accountService.acceptDisclaimer(DISCLAIMER_TYPES.NEW_CHECKOUT_FLOW, DISCLAIMER_MESSAGES.NEW_CHECKOUT_FLOW).subscribe({
      next: () => {
        this.#notificationService.show({ text: 'Thank you for accepting the new checkout flow!', type: 'success' });
        this.#signalsStoreService.setIsNewCheckoutFlowAccepted(true);
      },
      error: (error) => {
        console.error('Error accepting new checkout flow:', error);
      },
      complete: () => {
        this.#activeModal.close(true);
      }
    });
  }

}
